import React from 'react';
import {PropTypes} from 'prop-types';
import {ButtonIconOverlay, ButtonOverlay} from '@homeaway/react-buttons';
import {QUESTION__24} from '@homeaway/svg-defs';
import {SVGIcon} from '@homeaway/react-svg';
import './HelpButton.old.less';

class HelpButton extends React.Component {
    static propTypes = {
        onClick: PropTypes.func.isRequired,
        mediaMatches: PropTypes.shape({
            screenXsMax: PropTypes.boolean,
        }),
        helpText: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);
    }

    _onClick = () => {
        this.props.onClick();
    };

    render() {
        const props = this.props;
        return props.mediaMatches.screenXsMax ? (
            <ButtonIconOverlay
                className="OnboardingHelpButton mobile old"
                label="Default Button"
                svgMarkup={QUESTION__24}
                noBorder
                circle
                onClick={this._onClick}
            />
        ) : (
            <ButtonOverlay
                className="OnboardingHelpButton web old"
                onClick={this._onClick}
                label={
                    <React.Fragment key="OnboardingHelpLabel">
                        <SVGIcon className="OnboardingHelpIcon" inlineFlex markup={QUESTION__24} />
                        <span className="OnboardingHelpText">{props.helpText}</span>
                    </React.Fragment>
                }
            />
        );
    }
}

export default HelpButton;
